module.exports = __webpack_public_path__ + "img/details_bottom02.e7b059ea.png";